<dashboard-dialog-frame class="entrepreneur-prospect-dialog" [header]="headerName()" [actions]="actions()" [dialogRef]="dialogRef">

	<kendo-tabstrip class="h-100 px-2 pt-2">

		<kendo-tabstrip-tab title="Overview" [selected]="true">
			<ng-template kendoTabContent>
				<entrepreneur-prospect-overview-dialog-part>
				</entrepreneur-prospect-overview-dialog-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Courses">
			<ng-template kendoTabContent>
				<entrepreneur-prospect-dialog-courses-part [dialogBodyHeight]="dialogBodyHeight()"></entrepreneur-prospect-dialog-courses-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Applications">
			<ng-template kendoTabContent>
				<entrepreneur-prospect-dialog-applications-part [dialogBodyHeight]="dialogBodyHeight()"></entrepreneur-prospect-dialog-applications-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Aligned Commitments">
			<ng-template kendoTabContent>
				<entrepreneur-prospect-dialog-aligned-commitments-part [dialogBodyHeight]="dialogBodyHeight()"></entrepreneur-prospect-dialog-aligned-commitments-part>
			</ng-template>
		</kendo-tabstrip-tab>

		<kendo-tabstrip-tab title="Aligned Accelerators">
			<ng-template kendoTabContent>
				<entrepreneur-prospect-dialog-aligned-accelerators-part [dialogBodyHeight]="dialogBodyHeight()"></entrepreneur-prospect-dialog-aligned-accelerators-part>
			</ng-template>
		</kendo-tabstrip-tab>

	</kendo-tabstrip>

</dashboard-dialog-frame>